import React from "react";
import styles from "../../styles/components/uploadFile.module.scss";
import axios from "axios";
import Icons from "../../public/assets/svg";
import endpoints from "../../utility/endpoints";
import _get from "lodash/get";
import DropDown from "../listWithoutcheck";

export default function index(props) {

  //console.log(props,"upload props");
  const [invalidFile, setInvalidFile] = React.useState(false);
  const [uploading, setUploading] = React.useState(false);
  const [disabled, setDisabled] = React.useState(false);
  const [originalFileName, setOriginalFileName] = React.useState(null);
  const [originalFileName1, setOriginalFileName1] = React.useState('No file chosen');
  const [state, setState] = React.useState({ docType: "" });
  const [dropDownState, setDropdownState] = React.useState({ docType: false });

  const handleDropDown = (item) => {
    setDropdownState({
      ...dropDownState,
      [item]: !dropDownState[item],
    });
  };

  // dropdown value selected
 
  const handleFileChange = async (e, title) => {
   //console.log(props.fileType)
    if(props.chooseFile == 'onlySubmitAnIdea'){
      props.onUploadBtnClicked(); //For Error Msg when no file selected in submitAnIdea form
    }

    if (props.type == "demand") {
      //console.log("file name  ---", e.target.files[0].name);
      let fileNameExtension = e.target.files[0].name.split(".");
      fileNameExtension = fileNameExtension[fileNameExtension.length - 1];
      if (props.fileType.includes(fileNameExtension)) {
        props.uploadFile(e.target.files[0], e.target.name, title, fileNameExtension);
        setOriginalFileName(e.target.files[0].name);
        setOriginalFileName1(e.target.files[0].name);
        setInvalidFile(false);
      } else {
        setInvalidFile(true);
      }
    }
    else {
      let fileNameExtension = e.target.files[0].name.split(".");

      fileNameExtension = fileNameExtension[fileNameExtension.length - 1];

      //console.log("file name extension  ---", fileNameExtension);

       let extensionFlag = false;
       
       if (typeof props.fileType == "string") {
       
         if (props.fileType.includes(fileNameExtension)) {
           extensionFlag = true;
         }
       } else {
         
         for (let i in props.fileType) {
           if (props.fileType[i].includes(fileNameExtension)) {
             extensionFlag = true;
           }
         }
       }
        if (extensionFlag == true) {
           setOriginalFileName(e.target.files[0].name);
           setOriginalFileName1(e.target.files[0].name);
           console.log(e.target.files[0], "sd", e.target.name);
           props.uploadFile(
             e.target.files[0],
             e.target.name,
             title,
             e.target.files[0].name,
             fileNameExtension
           );
           if (props.type !== "framework") {
          
           }
          
           setInvalidFile(false);
         } else {
           setInvalidFile(true);
         }
    }
    e.target.value = "";
  }

  React.useEffect(() => {
    //console.log(props.uploaded, "uploadedddddddd")
    if (props.uploaded == true) {
      
      if (props.type == "createBot") {
        setDisabled(true);
      }
      
    } else {
      setDisabled(false);
    }
  }, [props.uploaded]);

  React.useEffect(() => {
    if (props.originalFileName != null && props.originalFileName.length > 0) {
      console.log(props.originalFileName, "originalestFileNames");
      setOriginalFileName(props.originalFileName);
      setOriginalFileName1(props.originalFileName);
    }
  }, [props.originalFileName]);


  React.useEffect(() => {
    if (props.currentlyUploading) {
      setDisabled(true)
    }
    else {
      if (!props.uploaded) {
        setDisabled(false)
      } 
    }

  }, [props.currentlyUploading ])

  return (
    <div className={styles.wrapper}>
      {/* {props.data == false ? null : <label>Upload file</label>} */}
      <div
        className={
          disabled == true ? styles.disabledInputGroup : styles.inputGroup
        }
      >

        {/* {props.type == "createBot" ? null :  <label>
          <span>Upload File</span>
        </label>} */}
        <div className={styles.uploadButton}>
          <label  for={props.value}>Select from device</label>
        </div>
          <input
            type="file"
            style = {{display:"none"}}
            id={props.value}
            onChange={(e) => {
              handleFileChange(e, props.title);
            }}
             name={props.value}
             disabled={disabled}
          />
        
        <span
          className={`${styles.fileName} ${props.uploaded == true
            ? styles.uploaded
            : props.couldNotUpload == true
              ? styles.errorUploading
              : uploading == true
                ? styles.uploading
                : null
            }`}
        >
{/*          {props.uploaded == true
            ? decodeURI(originalFileName)
            : props.couldNotUpload == true
              ? "Error while uploading"
              : uploading == true 
                ? "Uploading..."
                : " No file chosen"}*/}
{props.name=="editemployeetwin"?(props.uploaded == true
            ? decodeURI(originalFileName)
            : props.couldNotUpload == true
              ? "Error while uploading"
              : uploading == true 
                ? "Uploading..."
                : "Selected........"):
          (props.uploaded == true
            ? ((props.chooseFile == 'onlySubmitAnIdea') ? decodeURI(originalFileName1) : decodeURI(originalFileName))
            : props.couldNotUpload == true
              ? "Error while uploading"
              : uploading == true 
                ? "Uploading..."
                : " No file chosen")}
        </span>
      </div>
      <div>
       {  props.type == "createBot" && props.value !== "botDemoVideo" && !props.specialCase ? invalidFile ?  
       
        <p className={props.specialCase ?  !invalidFile ? styles.validFormatMsgSpecial : styles.invalidFormatMsgSpecial :  !invalidFile ? styles.validFormatMsg : styles.invalidFormatMsg}      style = {{    position: "absolute",
    left: "10px",
    bottom: "6px"}}>
           
      
            {/* {`Upload files in the format of ${typeof props.fileType == "string" ||
              typeof props.fileType == "object" ? props.fileType : `.mov, .avi, .mp4`}.`} */}
              Incorrect format
          </p>
          : null 
          : 
          <p className={props.specialCase ?  !invalidFile ? styles.validFormatMsgSpecial : styles.invalidFormatMsgSpecial :  !invalidFile ? styles.validFormatMsg : styles.invalidFormatMsg}>
          {`Upload files in the format of ${typeof props.fileType == "string" ||
            typeof props.fileType == "object" ? (props.fileType) : `.mov, .avi, .mp4`}.`}
        </p>
       }
      </div>
    </div>
  );
}


